import React, {useEffect} from 'react';
import PlayerDeleteFormContainer from '../../containers/PlayerDeleteFormContainer';


function PlayerDelete (props) {

    const { clearPlayer, getAPlayer, match, player } = props;

    useEffect(() => {
        clearPlayer();
        getAPlayer(match.params.playerId, match.params.id);
    }, [clearPlayer, getAPlayer, match]);


        return <div>
            {player && player.image ?
                <PlayerDeleteFormContainer />
                : '....loading'}
        </div>;
    }

    export default PlayerDelete;